import { render, staticRenderFns } from "./AmpliacionReduccionListView.vue?vue&type=template&id=1d6cfe63&"
import script from "./AmpliacionReduccionListView.vue?vue&type=script&lang=js&"
export * from "./AmpliacionReduccionListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports